import type { AdsMagnetoIHubClient } from "../api/magnetoApi/magnetoApi";
import { getMagnetoApi } from "../api/magnetoApi/magnetoApi";

import { zustandStore } from "./zustand.helpers";

const CACHE_DURATION = 60 * 60 * 1000; // 1 hour

interface CachedClient<T> {
    client: T | null;
    timestamp: number;
}

export interface ApiClientsState {
    magneto: CachedClient<AdsMagnetoIHubClient>;
}

export interface ApiClientsActions {
    getMagnetoClient: () => Promise<AdsMagnetoIHubClient>;
    clearMagnetoClient: () => void;
}

export const initialState: ApiClientsState = {
    magneto: {
        client: null,
        timestamp: 0,
    },
};

export const { store: apiClientsStore } = zustandStore<
    ApiClientsState,
    ApiClientsActions
>("ApiClients", initialState, (set, get) => ({
    getMagnetoClient: async () => {
        const { magneto } = get();
        const now = Date.now();

        if (magneto.client && now - magneto.timestamp < CACHE_DURATION) {
            return magneto.client;
        }

        const newClient = await getMagnetoApi();
        set(() => ({
            magneto: {
                client: newClient,
                timestamp: now,
            },
        }));

        return newClient;
    },
    clearMagnetoClient: () => {
        set(() => ({
            magneto: {
                client: null,
                timestamp: 0,
            },
        }));
    },
}));
